/** ID of the main vendor nav */
export const NAV_IDENTIFIER = 'vendor-nav';

export const NAV_SELECTOR = `#${NAV_IDENTIFIER}`;
